import React from 'react'
import { connect } from 'react-redux'
import { Icon } from 'semantic-ui-react'
const StandardButton = (props) => {
    const {
        label,
        customStyle,
        customColor = false,
        customColorText = false,
        icon = false,
        onClick,
        submit = false,
        disabled = false
    } = props
    return (
        <button  disabled={disabled} className={`${customStyle}  flex justify-center items-center 
            border-${customColor} bg-${customColor}
            text-${customColorText ? customColorText : 'gray-100'} 
            px-5 border rounded-lg  w-auto  h-10 text-center flex items-center`}
            onClick={() => onClick()}
            type={submit ? 'submit' : 'button'}>
            <span className='mr-1'>
                {icon ? <Icon name={icon}></Icon> : ""}
            </span>
            <span>
                {label}
            </span>
            
        </button >
    )
}

const mapStateToProps = (state) => {

    return {

    }
}

const mapDispatchToProps = {

}


export default connect(mapStateToProps, mapDispatchToProps)(StandardButton)